import BookingComponent from './booking-widget';
export default BookingComponent;